import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../style/pages/market_report.css";
import { useVuelidate } from "@vuelidate/core";
//@ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
import CommonModals from "./vue/CommonComponents/CommonModals";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import { useBaseSnackbar } from "@wkComposables/useBaseSnackbar";
import { createApp, defineAsyncComponent } from "vue";
import { useLoggedUserStore, usePublicUserMenuStore, useModalStore, useBaseStore, useMetadataStore
//@ts-ignore
} from "@store/index";
import { mapState, mapActions, createPinia } from "pinia";
//@ts-ignore
import { Modals } from "@customTypes/Modals";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useTrustpilotWidget } from "@wkComposables/useTrustpilotWidget";
//@ts-ignore
import RequestMrExampleForm from "@vueEntry/RequestMrExampleForm.vue";
var PAGE_ZOOMS;
(function (PAGE_ZOOMS) {
  // ENUM VENDITORE
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_DATI"] = 0] = "ZOOM_DATI";
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_INSIGHTS"] = 1] = "ZOOM_INSIGHTS";
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_BOUGHT_N_SOLD"] = 2] = "ZOOM_BOUGHT_N_SOLD";
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_ANALYSES"] = 3] = "ZOOM_ANALYSES";
  // ENUM ACQUIRENTE
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_DATI_BUYER"] = 4] = "ZOOM_DATI_BUYER";
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_BOUGHT_N_SOLD_BUYER"] = 5] = "ZOOM_BOUGHT_N_SOLD_BUYER";
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_ESTIMATE_N_MANAGEMENT_BUYER"] = 6] = "ZOOM_ESTIMATE_N_MANAGEMENT_BUYER";
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_INCOME_GENERATION_BUYER"] = 7] = "ZOOM_INCOME_GENERATION_BUYER";
})(PAGE_ZOOMS || (PAGE_ZOOMS = {}));
var marketReportApp = createApp({
  name: "MarketReport",
  components: Object.assign(Object.assign(Object.assign({
    PublicUserMenu,
    BaseInput,
    BaseButton,
    RequestMrExampleForm,
    //@ts-ignore
    "request-mr-example-modal": defineAsyncComponent(() => import("@vueEntry/Modals/RequestMrExampleModal.vue"))
  }, CommonModals), {
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseDropDown.vue"))
  }), LanguageIcons),
  setup() {
    var {
      isAppBannerVisible
    } = useAppBanner();
    var {
      showBaseSnackbar,
      handleShowSnackbar,
      baseSnackbarProps
    } = useBaseSnackbar();
    var {
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    } = useFirebaseMessaging();
    var {
      isLarge
    } = useBreakpoints();
    useTrustpilotWidget();
    return {
      v$: useVuelidate(),
      isLarge,
      isAppBannerVisible,
      showBaseSnackbar,
      handleShowSnackbar,
      baseSnackbarProps,
      //useFirebaseMessaging
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    };
  },
  data() {
    return {
      isLoading: false,
      firstCountUpText: 0,
      secondCountUpText: 0,
      thirdCountUpText: 0,
      isSeller: null,
      mrZoom: null,
      requestModalOpenedOnce: false,
      showReportBtn: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign({
    enumZooms() {
      return PAGE_ZOOMS;
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])), mapState(useMetadataStore, ["pageName"])),
  watch: {
    showModal(cur) {
      //Sending the event just once!
      if (cur === Modals.requestMrExample && !this.requestModalOpenedOnce) {
        sendGAEvent("mr_open_form", {
          event_location: "".concat(this.pageName, " - Modale Richiedi Report di esempio")
        });
        this.requestModalOpenedOnce = true;
      }
    }
  },
  created() {
    this.initPublicUserMenu();
  },
  mounted() {
    window.addEventListener("scroll", this.checkScroll);
    this.observerContainer("mr-rating1", 67);
    this.observerContainer("mr-rating2", 86);
  },
  methods: Object.assign(Object.assign({
    checkScroll(mainElement, footerElement) {
      this.showReportBtn = window.scrollY > 50 && window.scrollY < 3300;
    },
    setMrZoom(isSeller) {
      this.mrZoom = null;
      this.isSeller = isSeller;
      if (isSeller) {
        this.$nextTick(() => {
          var _a;
          (_a = document.getElementById("mr-venditore-img")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        });
      } else {
        this.$nextTick(() => {
          var _a;
          (_a = document.getElementById("mr-acquirente-img")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        });
      }
    },
    setZoom(enumZooms) {
      this.mrZoom = enumZooms;
    },
    observerContainer(observedItem, endNr, duration) {
      var target = document.getElementById(observedItem);
      if (!target) return;
      var observerTarget = target;
      if (target) {
        var callback = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                this.mrCountUp(endNr, observedItem, duration).then(() => {
                  observer.unobserve(observerTarget);
                });
              }, 500);
            }
          });
        };
        var observer = new IntersectionObserver(callback, this.observerOptions);
        observer.observe(target);
      }
    },
    mrCountUp(endNr, itemToCountup) {
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1.5;
      return __awaiter(this, void 0, void 0, function* () {
        var animationDuration = duration * 1000;
        var frameDuration = 1000 / 60;
        var totalFrames = Math.round(animationDuration / frameDuration);
        var easeOutQuad = t => {
          return t * (2 - t);
        };
        var countTo = endNr;
        var frame = 0;
        try {
          var counter = setInterval(() => {
            frame++;
            var progress = easeOutQuad(frame / totalFrames);
            var currentCount = Math.round(countTo * progress);
            if (this.textEl !== currentCount) {
              switch (itemToCountup) {
                case "mr-rating1":
                  this.firstCountUpText = currentCount;
                  break;
                case "mr-rating2":
                  this.secondCountUpText = currentCount;
                  break;
              }
            }
            if (frame === totalFrames) clearInterval(counter);
          }, frameDuration);
        } catch (err) {
          console.log(err);
        }
      });
    },
    scrollDown() {
      window.scrollBy(0, window.innerHeight);
    }
  }, mapActions(useBaseStore, ["logout", "initPublicUserMenu"])), mapActions(useModalStore, ["setShowModal"]))
});
marketReportApp.use(createPinia());
marketReportApp.mount("#market-report-main");